import React, { ReactNode } from "react";
import styled from "styled-components";
import tw from "twin.macro";

import Container from "../common/Container";
import HeaderNav from "./HeaderNav";

const Wrapper = styled.div`
  ${tw`fixed top-0 left-0 right-0 z-30`}
  border-bottom: 1px solid transparent;
  transition: border background 250ms ease-in-out;

  body.scrolled & {
    ${tw`bg-white`}
    border-bottom: 1px solid #E0E0E0;
    box-shadow: 0px 0px 40px rgba(0, 0, 0, 0.07);
  }
`;

const RootNav = styled.div`
  ${tw`flex items-center h-[96px]`}
`;

interface HeaderProps {
  nav?: ReactNode;
}

const Header: React.FunctionComponent<HeaderProps> = ({
  nav = <HeaderNav />,
}) => (
  <>
    <Wrapper>
      <RootNav>
        <Container>{nav}</Container>
      </RootNav>
    </Wrapper>
  </>
);

export default Header;
